
import { TweenLite, TimelineMax, Timeline} from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { Currency } from "@nolimitcity/slot-game/bin/core/balance/Currency";
import { BitmapTextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import { PunkBitmapCountUp } from "../../../component/PunkBitmapCountUp";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";

export class PunkCounter extends PIXI.Container {

    private readonly _style:BitmapTextStyleOptions;
    protected _countUp:PunkBitmapCountUp;
    protected _timeline:TimelineMax | null;

    constructor(style:BitmapTextStyleOptions) {
        super();
        this._style = style;
        this.init();
    }

    protected init():void {
        this._countUp = new PunkBitmapCountUp({
            style : this._style
        });
        this._countUp.shrinkSize = true;
        this._countUp.maxTextWidth = PunkEngineManager.ReelAreaWidth;
        this._countUp.alpha = 0;
        this.addChild(this._countUp);
    }

    public abort(endValue:number):void {
        this._timeline = Helper.timeLineKiller(this._timeline as TimelineMax, new TimelineMax());
        this._countUp.text = Currency.formatValue(endValue);
        this._countUp.updateCountUpTextPivot();
        this._timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01}));
        this._timeline.add(TweenLite.to(this._countUp, 0.2, {alpha : 0}), `+=0.8`); // stay a while after count up.
    }
}
